export default __webpack_public_path__ + "static/1188-0e2472da480b047b246a96c14c8065a9.gif";